import Counter from './components/Counter';
import GlobalStyle from './GlobalStyle';

function App() {
  return (
    <>
      <GlobalStyle />
      <Counter />
    </>
  );
}

export default App;
